import { ToursDashboardTypes } from 'dashboard/_redux/types/toursDashboardTypes';
import { emptyPaginationPayload } from 'server/constants/emptyPaginationPayload';
import { ITour } from 'client/models/ITour';
import { IReduxAction } from 'types/IReduxAction';
import { PaginatedResponse } from 'types/Posts';

export interface IToursDashboardState {
  loading: boolean;
  loaded: boolean;
  tours: PaginatedResponse<ITour>;
  selectedTour?: ITour;
}

const initialState: IToursDashboardState = {
  loading: false,
  loaded: false,
  tours: emptyPaginationPayload,
};

export default (
  state = initialState,
  { type, payload }: IReduxAction,
): IToursDashboardState => {
  switch (type) {
    case ToursDashboardTypes.FETCH_TOURS_SUCCESS:
      return { ...state, loaded: true, tours: payload };
    case ToursDashboardTypes.UPDATE_TOUR_SUCCESS:
      return { ...state, loaded: true, selectedTour: payload };

    default:
      return state;
  }
};
